<template>
    <div class="subscription-progress-timeline">
        <h3 class="mb-4">{{ $t('cdb.subscriptions.history') }}</h3>
        <ul class="list-unstyled">
            <li class="mb-3" v-if="hasSubscriptionEndDate">
                <data-entry-column
                    :title="$t('cdb.subscriptions.end_of_subscription.fixed')"
                    :value="subscriptionEndDate"
                    :full-width="true"
                    class="px-0 text-muted"
                >
                </data-entry-column>
                <div class="vertical-dashed-spacer pb-2"></div>
            </li>
            <li class="mb-3" v-else-if="willHaveSubscriptionEndDate">
                <data-entry-column
                    :title="$t('cdb.subscriptions.end_of_subscription')"
                    :value="$t('cdb.subscriptions.no_end_of_subscription')"
                    :full-width="true"
                    class="px-0 text-muted"
                >
                    <template v-slot:action>
                        <span class="text-link text-danger" @click="openCancelSubscriptionModal">{{ $t('cdb.subscriptions.quit') }}</span>
                    </template>
                </data-entry-column>
                <div class="vertical-dashed-spacer pb-2"></div>
            </li>
            <li v-for="entry in formattedEntries" :key="entry.timestamp" class="mb-3">
                <data-entry-column
                    :title="$t('history.'+entry.event+'.title', JSON.parse(entry.data))"
                    :value="entry.localeDateString +' - '+ $t('history.'+entry.event+'.description', JSON.parse(entry.data))"
                    :full-width="true"
                    class="px-0"
                    :abbreviated="false"
                >
                </data-entry-column>
                <div class="vertical-spacer pb-2"></div>
            </li>
        </ul>
    </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import DataEntryColumn from "../atoms/DataEntryColumn.vue";

export default {
    name: 'SubscriptionProgressTimeline',
    components: {
        DataEntryColumn
    },
    data() {
        return {
            entries: [],
        }
    },
    props: {
        subscriptionData: {
            type: Object,
            required: true
        },
        hasSubscriptionEndDate: {
            type: Boolean,
            required: true
        },
        willHaveSubscriptionEndDate: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        formattedEntries() {
            const datesToFormat = ['contract_started_at', 'contract_ended_at', 'vehicle_returned_at', 'cancel_to'];
            this.entries = this.subscriptionData.history;
            const entriesForCustomer = this.entries.filter(entry => entry.is_interal !== 1);

            entriesForCustomer.forEach(entry => {
                // Überprüfen und Formatieren des entry.timestamp
                if (entry.timestamp) {
                    const date = new Date(entry.timestamp);
                    if (!isNaN(date.getTime())) {
                        entry.localeDateString = this.formatDate(date);
                    }
                }
                // Überprüfen und Verarbeiten von entry.data
                if (entry.data !== null) {
                    let data = JSON.parse(entry.data);
                    let pattern = /^\d{2}\.\d{2}\.\d{4}$/;
                
                    datesToFormat.forEach(date => {
                        if (data.hasOwnProperty(date) && data[date]) {
                            if (!pattern.test(data[date])) {
                                const dateToCheck = new Date(data[date]);
                                if (!isNaN(dateToCheck.getTime())) {
                                    data[date] = this.formatDate(dateToCheck);
                                } 
                            }
                        }
                    });
                    entry.data = JSON.stringify(data);
                }
            });
            return entriesForCustomer.reverse();
        },
        subscriptionEndDate() {
            if (this.hasSubscriptionEndDate){
                return this.$d(new Date(this.subscriptionData.timestamps.cancel_to * 1000), 'short')
            } else {
                return this.$t('cdb.subscriptions.not_specified')
            }
        }
    },
    methods: {
        openCancelSubscriptionModal() {
            EventBus.$emit('init-cancel-subscription', {subscription: this.subscriptionData});
        },
        formatDate(date) {
            var date_format = this.$root.$i18n.locale.includes('US') ? 'us' : 'eu'

            const day = (`0${date.getDate()}`).slice(-2);
            const month = (`0${date.getMonth() + 1}`).slice(-2);
            const year = date.getFullYear();
            
            if (date_format === 'us') {
              return `${month}/${day}/${year}`;
            } else {
              return `${day}.${month}.${year}`;
            }
        }
    }
}
</script>
